import * as React from 'react';
import { Theme, createStyles } from '@material-ui/core';
import { FieldProps } from 'yafl';
import { FieldValidator } from 'shared/form/validators';
import { createStyled } from 'shared/hocs';
import { TextField } from 'shared/components';
import { TextFieldProps } from '@material-ui/core/TextField';

interface Props<T> extends FieldProps<any, T> {
  id?: string;
  label?: string;
  type?: string;
  loading?: boolean;
  validators?: Array<FieldValidator<T>>;
}

class FormTextInput<
  T extends string | number | boolean
> extends React.Component<Props<T> & TextFieldProps> {
  render() {
    const {
      meta,
      input,
      label,
      type,
      loading,
      placeholder,
      disabled,
      ...props
    } = this.props;
    const { isValid, visited, submitCount, errors = [] } = meta;
    const showError = !isValid && (visited || submitCount > 0);
    return (
      <>
        <Styled>
          {({ classes }) => (
            <TextField
              {...input}
              {...props}
              type={type}
              label={label}
              error={showError}
              disabled={disabled}
              helperText={showError && errors[0]}
              placeholder={placeholder}
            />
          )}
        </Styled>
      </>
    );
  }
}

const Styled = createStyled((theme: Theme) =>
  createStyles({
    // error: {
    //     color: theme.palette.error.main;
    //     margin-top: 0.25rem;
    // }
  }),
);

export default FormTextInput;
